import React from 'react';
import PropTypes from 'prop-types';
import { FILTER_IDS, ONLINE_SCHEDULING_TYPE } from '@src/js/constants';
import { SearchFilter } from '@src/components/core/core-component-imports';
import FindAProviderResultsContentType from '@js/content-types/find-a-provider-results-content-type.es6';

/**
 * Renders a provider-level search filter for online scheduling availability options.
 * Click handlers handled in hooks.
 */
const OnlineSchedulingSearchFilter = ({ open, clickHandler }) => {
  const findAProviderResults = new FindAProviderResultsContentType();
  const filterName = findAProviderResults.onlineSchedulingOptionsFilterLabel.item.$(0).text();
  const inPersonVisitsOption = findAProviderResults.inPersonOnlineSchedulingAvailableOptionLabel.item.$(0).text();
  const telemedicineVisitsOption = findAProviderResults.telemedicineOnlineSchedulingAvailableOptionLabel.item.$(0).text();
  const inPersonOrTelemedicineVisitsOption = findAProviderResults.inPersonOrTelemedicineOnlineSchedulingAvailableOptionLabel.item.$(0).text();
  const applyFilterLabel = findAProviderResults.applyFilterLabel.item.$(0).text();
  const clearLabel = findAProviderResults.clearLabel.item.$(0).text();
  const searchPlaceholder = findAProviderResults.searchPlaceholder.item.$(0).text();

  const options = {
    [ONLINE_SCHEDULING_TYPE.IN_PERSON]: {
      label: inPersonVisitsOption,
    },
    [ONLINE_SCHEDULING_TYPE.TELEMEDICINE]: {
      label: telemedicineVisitsOption,
    },
    [ONLINE_SCHEDULING_TYPE.IN_PERSON_OR_TELEMEDICINE]: {
      label: inPersonOrTelemedicineVisitsOption,
    },
  };

  return (
    <SearchFilter
      name={filterName}
      queryParameterName={FILTER_IDS.ONLINE_SCHEDULING_TYPE}
      options={options}
      open={open}
      clickHandler={clickHandler}
      applyFilterLabel={applyFilterLabel}
      clearLabel={clearLabel}
      searchPlaceholder={searchPlaceholder}
    />
  );
}

OnlineSchedulingSearchFilter.propTypes = {
  /**
   *  determines if the filter is active for user selection (when true) or closed (when false)
   */
  open: PropTypes.bool.isRequired,
  /**
   * the callback function for when the filter button is clicked
   */
  clickHandler: PropTypes.func.isRequired,
};

export default OnlineSchedulingSearchFilter;
